<mat-tab-group>
    <mat-tab label="Detail">
        <ng-template matTabContent>
            <form
                *ngIf="formGroup"
                [formGroup]="formGroup">
                <app-question [question]="questions.alias"></app-question>
                <app-question [question]="questions.text"></app-question>
            </form>
            <app-button-list>
                <app-button
                    #saveButton
                    [disabled]="!formGroup.valid"
                    [loading]="saving"
                    (clickedEvent)="save()">Save </app-button>
            </app-button-list>

            <div class="margin-top-lg">
                <h4>Preview</h4>
                <app-render-html [html]="controls.text.value"></app-render-html>
            </div>
        </ng-template>
    </mat-tab>
</mat-tab-group>
